import React, { useRef, useState } from "react";
import { Link, useNavigate } from "react-router-dom";
// import emailjs from "@emailjs/browser";
import Alert from "react-bootstrap/Alert";
import HeaderFour from "../common/header/HeaderFour";
import FooterOne from "../common/footer/FooterOne";
import { initializeApp } from "firebase/app";
import { getAuth, signInWithPopup, GoogleAuthProvider } from "firebase/auth";
import API_BASE_URL from "./../common/config";
import API_URL_dash from "../common/config2";
import {
  ErrorNotification,
  SuccessNotification,
} from "../tosterNotification/tosters";
import SEO from "../common/SEO";

// Firebase configuration
const firebaseConfig = {
  apiKey: "AIzaSyBAMtvrbKK1p7hTG1V2AYz2bpGpGDcUAMQ",
  authDomain: "clifai-cd683.firebaseapp.com",
  projectId: "clifai-cd683",
  storageBucket: "clifai-cd683.firebasestorage.app",
  messagingSenderId: "1001395506359",
  appId: "1:1001395506359:web:a819d14200c1de7aae5132",
  measurementId: "G-YH75BT5LTN",
};

const app = initializeApp(firebaseConfig);
const auth = getAuth(app);

const Login = () => {
  const form = useRef();
  const navigate = useNavigate();
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [error, setError] = useState("");
  const [result, showResult] = useState(false);
  const [showPassword, setShowPassword] = useState(false);

  const handleGoogleSignIn = async () => {
    const provider = new GoogleAuthProvider();
    try {
      const loginResult = await signInWithPopup(auth, provider);
      console.log("Google Login Success:", loginResult);

      const { email, displayName } = loginResult.user;
      const nameParts = displayName.split(" ");
      const firstname = nameParts[0];
      const lastname = nameParts.length > 1 ? nameParts[1] : "";

      // Send data to backend
      console.log("Sending Data to Backend:", { email, firstname, lastname });

      const response = await fetch(`${API_BASE_URL}/auth/google`, {
        method: "POST",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify({ email, firstname, lastname }),
      });

      const result = await response.json();

      // Handle different cases based on response
      if (!response.ok) {
        if (
          response.status === 403 &&
          result.message === "User not found. Please sign up."
        ) {
          // Handle user not found (prompt for sign-up)
          setError("User not found. Please sign up.");
          ErrorNotification("User not found. Please sign up.");
          navigate("/subscription");
        } else if (response.status === 401) {
          setError("Subscription Expired");
          ErrorNotification("Subscription Expired");
          navigate("/feedback");
        } else {
          throw new Error(result.message || "Google login failed");
        }
      } else {
        console.log("Google Sign-in Result:", result);
        console.log("Subscription Status:", result.subscription?.status);
        console.log("Full Subscription Object:", result.subscription);

        // Check for pending payment status
        if (result.subscription && result.subscription.status === "pending") {
          ErrorNotification("Payment is pending");
          navigate("/payment", {
            state: {
              planName: "STANDARD PLAN",
              planPrice: "$21",
              planDuration: "1 month",
              stripePriceId: "price_1RGJ6cQ2THmJYdbgucRnB46i",
              userName: `${result.user.firstname} ${result.user.lastname}`,
              userEmail: result.user.email,
            },
          });
          return;
        }

        // Store tokens in localStorage (on port 3000)
        localStorage.setItem("token", JSON.stringify(result.token));
        localStorage.setItem(
          "refreshToken",
          JSON.stringify(result.refreshToken)
        );
        localStorage.setItem("user", JSON.stringify(result.user));
        localStorage.setItem("sUserid", JSON.stringify(result.user._id));

        console.log("sUserid", JSON.stringify(result.user._id));

        if (result.user._id) {
          SuccessNotification("Login Successfully");
          showResult(true);

          // Pass authentication data via URL parameters for dashboard (port 3001)
          const userData = encodeURIComponent(JSON.stringify(result.user));
          const userId = result.user._id;
          const token = result.token
            ? encodeURIComponent(JSON.stringify(result.token))
            : "";
          const refreshToken = result.refreshToken
            ? encodeURIComponent(JSON.stringify(result.refreshToken))
            : "";

          // Redirect with all necessary auth data
          window.location.href = `${API_URL_dash}/dashboard?userData=${userData}&userId=${userId}&token=${token}&refreshToken=${refreshToken}`;
        }
      }
    } catch (err) {
      console.error("Google login error:", err);
      setError("Google login failed. Please try again.");
    }
  };

  // Handle manual email/password login
  const handleManualLogin = async (e) => {
    e.preventDefault();
    try {
      const response = await fetch(`${API_BASE_URL}/auth/login`, {
        method: "POST",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify({ email, password }),
      });

      if (!response.ok) {
        const errorMessage = await response.json();
        ErrorNotification(errorMessage.message);
        if (errorMessage.message === "Subscription expired") {
          console.log("subscription expired");
          navigate("/feedback");
        }
        return;
      }

      const result = await response.json();
      console.log("Result", result);
      if (result.subscription.status === "pending") {
        ErrorNotification("Payment is pending");
        navigate("/payment", {
          state: {
            planName: "STANDARD PLAN",
            planPrice: "$21",
            planDuration: "1 month",
            stripePriceId: "price_1RGJ6cQ2THmJYdbgucRnB46i",
            userName: `${result.data.firstname} ${result.data.lastname}`,
            userEmail: result.data.email,
          },
        });
        return;
      }

      if (result.data._id) {
        // Store data in localStorage (for port 3000)
        localStorage.setItem("user", JSON.stringify(result.data));
        localStorage.setItem("sUserid", result.data._id);
        console.log("sUserid", result.data._id);

        SuccessNotification("Login Successfully");
        showResult(true);

        // Pass authentication data via URL parameters for dashboard (port 3001)
        const userData = encodeURIComponent(JSON.stringify(result.data));
        const userId = result.data._id;

        // Get tokens if available
        const token = result.token
          ? encodeURIComponent(JSON.stringify(result.token))
          : "";
        const refreshToken = result.refreshToken
          ? encodeURIComponent(JSON.stringify(result.refreshToken))
          : "";

        // Redirect with all necessary auth data
        window.location.href = `${API_URL_dash}/dashboard?userData=${userData}&userId=${userId}&token=${token}&refreshToken=${refreshToken}`;
      }
    } catch (err) {
      setError(err.message);
      ErrorNotification(err.message);
    }
  };

  setTimeout(() => {
    showResult(false);
  }, 5000);

  return (
    <>
      <SEO />
      <main className="main-wrapper">
        <HeaderFour />
        <div
          className="section section-padding"
          style={{
            position: "relative",
          }}
        >
          <div className="container mt-5">
            <div className="row justify-content-center">
              <div className="col-xl-5 col-lg-6">
                <div className="contact-form-box shadow-box ">
                  <h3 className="title text-center">Let's Get Started </h3>
                  <h5 className="text-center">
                    Not a member yet?
                    <Link to="/subscription" style={{ color: "#6600CC" }}>
                      &nbsp; Sign Up
                    </Link>
                  </h5>
                  {/* <div className="form-group">{result ? <Result /> : null}</div> */}
                  {error && <Alert variant="danger">{error}</Alert>}
                  <form
                    ref={form}
                    onSubmit={handleManualLogin}
                    className="axil-contact-form"
                  >
                    <div className="form-group">
                      <label style={{ textTransform: "capitalize" }}>
                        Email address*
                      </label>
                      <input
                        type="email"
                        className="form-control"
                        placeholder="name@gmail.com"
                        name="email"
                        value={email}
                        onChange={(e) => setEmail(e.target.value)}
                        required
                      />
                    </div>
                    <div className="form-group">
                      <label>Password*</label>
                      <div
                        className="input-wrapper"
                        style={{
                          position: "relative",
                          display: "flex",
                          alignItems: "center",
                        }}
                      >
                        <input
                          type={showPassword ? "text" : "password"}
                          className="form-control"
                          placeholder="********"
                          name="password"
                          value={password}
                          onChange={(e) => setPassword(e.target.value)}
                          required
                          style={{
                            width: "100%",
                            paddingRight: "40px",
                            paddingLeft: "15px",
                            paddingTop: "10px",
                            paddingBottom: "10px",
                            backgroundColor: "#f9f9f9",
                            border: "1px solid #ddd",
                            borderRadius: "10px",
                            fontSize: "16px",
                            outline: "none",
                          }}
                        />
                        <i
                          className={`fas ${
                            showPassword ? "fa-eye-slash" : "fa-eye"
                          }`}
                          onClick={() => setShowPassword(!showPassword)}
                          style={{
                            position: "absolute",
                            right: "12px",
                            color: "#888",
                            cursor: "pointer",
                            fontSize: "18px",
                          }}
                        ></i>
                      </div>
                    </div>
                    <p className="mb-2 fs-3 mt-0">
                      <Link
                        to="/forget-password"
                        style={{
                          textTransform: "capitalize",
                          textDecoration: "underline",
                        }}
                      >
                        forget password ?
                      </Link>
                    </p>
                    <div className="form-group gap-2 flex-row">
                      <button
                        type="submit"
                        className="axil-btn try-free-btn btn-fluid btn-primary"
                        name="submit-btn"
                      >
                        Log In
                      </button>
                      <button
                        type="button"
                        onClick={handleGoogleSignIn}
                        className="btn btn-light d-flex align-items-center justify-content-center w-100"
                        style={{
                          height: "50px",
                          marginTop: "5px",
                          borderRadius: "12px",
                          background:
                            "linear-gradient(135deg,rgb(228, 219, 244),rgb(227, 208, 255))",
                          color: "#4a3f75",
                          fontWeight: "500",
                          boxShadow: "0 4px 6px rgba(0, 0, 0, 0.1)",
                          transition: "all 0.3s ease",
                        }}
                        onMouseOver={(e) =>
                          (e.target.style.background =
                            "linear-gradient(135deg, #e9dfff, #c79fff)")
                        }
                        onMouseOut={(e) =>
                          (e.target.style.background =
                            "linear-gradient(135deg, #f5f0ff, #d6b8ff)")
                        }
                      >
                        <img
                          src="https://www.svgrepo.com/show/452216/google.svg"
                          alt="Google"
                          className="me-2"
                          style={{ height: "20px" }}
                        />
                        Sign In with Google
                      </button>
                    </div>
                  </form>
                </div>
              </div>
            </div>
          </div>
          <ul className="shape-group-8 list-unstyled">
            <li className="shape shape-1">
              <img
                src={process.env.PUBLIC_URL + "/images/others/bubble-9.png"}
                alt="Bubble"
              />
            </li>
            <li className="shape shape-2">
              <img
                src={process.env.PUBLIC_URL + "/images/others/bubble-11.png"}
                alt="Bubble"
              />
            </li>
            <li className="shape shape-3">
              <img
                src={process.env.PUBLIC_URL + "/images/others/line-4.png"}
                alt="Line"
              />
            </li>
          </ul>
        </div>
        <FooterOne />
      </main>
    </>
  );
};

export default Login;
